import React, { PureComponent } from 'react';

class RegistroGrilla extends PureComponent {
    constructor(props) {
        super(props);

        this.routeToABMModelos = this.routeToABMModelos.bind(this);
    }

    componentDidMount(){
        $('[data-toggle="tooltip"]').tooltip();
    }

    routeToABMModelos(codigo) {
        this.props.routeToABMModelos(codigo);
    }

    render() {
        const { data, esPar } = this.props;

        let estiloPar = esPar ? " seccionGrilla__registro--registroGris" : "";

        return (
            <div className={"seccionGrilla__registro" + estiloPar} onClick={() => this.routeToABMModelos(data.Codigo)}>
                <div className="seccionGrilla__registro__Codigo">
                    {data.Codigo}
                </div>

                <div className="seccionGrilla__registro__Descripcion">
                    {data.Descripcion}
                </div>

                <div className="seccionGrilla__registro__Marca">
                    {data.Marca || "AD17"}
                </div>

                <div className="seccionGrilla__registro__TipoMovimiento">
                    {data.Movimientos}
                </div>

                <div className="seccionGrilla__registro__Inactivo">
                    {data.Activo ? 
                        "" 
                    : 
                        <div>
                            <div className="seccionGrilla__registroIconoInactivo" data-toggle="tooltip" data-title="Inactivo" data-placement="left" data-original-title="" title=""></div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default RegistroGrilla;